import React, {useEffect, useState} from "react"
import MetaTags from "react-meta-tags"
import {Container, Card, CardBody, Nav, NavItem, NavLink} from "reactstrap"
import classnames from "classnames"
import {withRouter} from "react-router"
import {withTranslation} from "react-i18next"
import PropTypes from "prop-types"
import DataTableFicheVoeuxSurveillance from "./DataTableFicheVoeuxSurveillance";
import AddFicheVoeuxSurveillance from "./AddFicheVoeuxSurveillance";

const FicheVoeuxSurveillance = props => {
    var userAuthEnseignant = JSON.parse(
        localStorage.getItem("userAuthEnseignant")
    )
    var chefDepartement = userAuthEnseignant.user.chef
    const [section, setSection] = useState(1)

    const back = () => {
        setSection(1)
    }

    const renderBlock = section => {
        if (section === 1) {
            return <DataTableFicheVoeuxSurveillance/>
        }else if(section === 2) {
            return <AddFicheVoeuxSurveillance back={back} setSection={setSection}/>
        }
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>{props.t("Fiche de voeux")} | Cresus </title>
                </MetaTags>
                <Container fluid>
                    <div>
                        <Nav tabs>
                            <NavItem>
                                <NavLink
                                    style={{cursor: "pointer"}}
                                    className={classnames({
                                        active: section === 1,
                                    })}
                                    onClick={() => {
                                        setSection(1)
                                    }}
                                >
                                    {props.t("Fiche de voeux surveillance")}
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    style={{cursor: "pointer"}}
                                    className={classnames({
                                        active: section === 2,
                                    })}
                                    onClick={() => {
                                        setSection(2)
                                    }}
                                >
                                    {props.t("Ajouter Fiche de voeux surveillance")}
                                </NavLink>
                            </NavItem>


                        </Nav>
                        <Card>
                            <CardBody>{renderBlock(section)}</CardBody>
                        </Card>
                    </div>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default withRouter(withTranslation()(FicheVoeuxSurveillance))
FicheVoeuxSurveillance.propTypes = {
    t: PropTypes.any,
}
